import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { updateType, search } from '../../../state/actions';
import { StateType } from '../../../../state/state.types';

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onTypeChanged(type: keyof StateType['results']['counts']) {
    dispatch(updateType(type));
    dispatch(search({ reason: 'type_changed' }));
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
